import {Component, OnInit} from '@angular/core';
import {NavigationService} from '../../../../../../../../shared/services/navigation/navigation.service';
import {ActivatedRoute} from '@angular/router';
import {TypPrzedmiotuUbezpieczenia} from '../../../../../../../../shared/model/przedmioty/typPrzedmiotuUbezpieczenia';
import {
  LokalizacjaUszkodzenia,
  lokalizacjeUszkodzenMieszkanie
} from '../../../../../../../../shared/model/uszkodzenia/lokalizacja-uszkodzenia';

@Component({
  selector: 'app-pomieszczenia',
  templateUrl: 'pomieszczenia.component.html'
})
export class PomieszczeniaComponent implements OnInit {

  constructor(public route: ActivatedRoute, public navigation: NavigationService) {
  }

  typPrzedmiotu!: string
  idPrzedmiotu!: number

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.typPrzedmiotu = params.typ;
      this.idPrzedmiotu = params.id;
    });
  }

  pobierzLokalizacjePomieszczen(): Array<LokalizacjaUszkodzenia> | undefined {
    switch (this.typPrzedmiotu) {
      case TypPrzedmiotuUbezpieczenia.DOM_JEDNORODZINNY.nazwa:
        return lokalizacjeUszkodzenMieszkanie.concat(LokalizacjaUszkodzenia.POMIESZCZENIE_GARAZOWE_DOM);
      default:
        return undefined;
    }
  }
}
